<template>
  <div class="container pb-5 charges-calculator">
    <ol class="breadcrumb arr-right mb-0 mb-md-3 mt-5">
      <li class="breadcrumb-item">
        <router-link :to="{ name: 'chargesCalculator' }" class="headings">{{
          $t('chargesCalculator.index.title')
        }}</router-link>
      </li>
      <li class="breadcrumb-item reference-heading heading-color">
        {{ $t('chargesCalculator.index.list') }}
      </li>
    </ol>
    <div class="drip-form-container select-invoice">
      <div class="drip-form">
        <label class="mb-3 mt-3 heading-desc">
          <h5>{{ $t('chargesCalculator.index.selectInvoice.label') }}</h5>
        </label>
        <b-form-group class="form-buyer dc-group" :class="'is-empty'">
          <multiselect
            v-model="selectedInvoice"
            :options="invoices"
            name="selectedInvoice"
            label="reference"
            @input="onSelect"
            @search-change="searchChange"
            :selectLabel="$t('multiselect.selectLabel')"
            :deselectLabel="$t('multiselect.deSelectLabel')"
            :selectedLabel="$t('multiselect.selectedLabel')"
            :placeholder="
              $t('chargesCalculator.index.selectInvoice.placeHolder')
            "
          >
            <span class="action-input" slot="caret">
              <b-icon-chevron-down />
            </span>
            <template slot="noResult">
              <div>
                <span>{{
                  this.$t('chargesCalculator.index.selectInvoice.noResults') +
                  this.searchQuery
                }}</span>
              </div>
            </template>
          </multiselect>
        </b-form-group>
      </div>
    </div>
    <template v-if="!loading">
      <div
        class="d-flex justify-content-center align-items-center flex-column"
        v-if="!selectedInvoice"
      >
        <b-img
          :src="require('@/assets/images/invoice-calculation.svg')"
          class="text-center"
        ></b-img>
        <p>{{ $t('chargesCalculator.index.selectInvoice.text') }}</p>
      </div>
      <div v-if="selectedInvoice" class="field-wrap">
        <h5>{{ $t('chargesCalculator.index.invoiceDetails.title') }}</h5>
      </div>
      <b-card v-if="selectedInvoice">
        <b-table class="calc-table" :items="tableItems" :fields="tableFields">
        </b-table>
      </b-card>
      <div v-if="selectedInvoice" class="field-wrap">
        <h5>{{ $t('chargesCalculator.index.calcDetailsTable.title') }}</h5>
      </div>
      <b-card v-if="selectedInvoice">
        <b-table
          class="calc-table"
          :fields="tableBreakupFields"
          :items="tableBreakupItems"
        >
          <template v-slot:head(asOn)="data">
            <div
              class="d-flex flex-column flex-md-row align-items-center justify-center"
            >
              <div>
                <span class="mr-2 text-uppercase">{{ data.label }}</span>
              </div>
              <div class="date-picker-wrap position-relative flex-grow-1">
                <date-picker
                  autocomplete="off"
                  name="invoice_date"
                  v-model="invoice_date"
                  :placeholder="
                    $t('invoices.add.helpers.invoiceDate.placeHolder')
                  "
                  ref="invoiceDate"
                  :config="options"
                  @input="onDateSelect"
                  v-validate="'required'"
                >
                </date-picker>
                <span
                  class="action-input"
                  slot="caret"
                  @click="$refs.invoiceDate.$el.focus()"
                  ><b-icon-calendar2-event-fill font-scale="0.8"
                /></span>
              </div>
            </div>
          </template>
          <template v-slot:cell(PARTICULARS)="data">
            <div v-html="data.value"></div>
          </template>
          <template v-slot:cell(expectedOnDueDate)="data">
            <div v-html="data.value"></div>
          </template>
          <template v-slot:cell(asOn)="data">
            <div v-html="data.value"></div>
          </template>
        </b-table>
      </b-card>
    </template>
    <loader v-else />
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue-bootstrap-datetimepicker'
import invoiceService from '@/services/invoice'
import Loader from '@/components/common/Loader'
export default {
  data() {
    return {
      loading: false,
      invoices: [],
      selectedInvoice: '',
      selectedValue: '',
      invoiceDetails: null,
      invoiceCalculationOnDate: {
        advances: []
      },
      selectedDate: this.formatDate(new Date()),
      tableFields: [
        {
          key: 'PARTICULARS',
          label: this.$t(
            'chargesCalculator.index.invoiceDetails.headers.particulars'
          ),
          thClass: 'text-primary align-self-center'
        },
        {
          key: 'VALUE',
          label: this.$t(
            'chargesCalculator.index.invoiceDetails.headers.value'
          ),
          thClass: 'text-primary align-self-center'
        }
      ],
      tableBreakupFields: [
        {
          key: 'PARTICULARS',
          label: this.$t(
            'chargesCalculator.index.calcDetailsTable.headers.particulars'
          ),
          thClass: 'text-primary va-middle'
        },
        {
          key: 'expectedOnDueDate',
          label: this.$t(
            'chargesCalculator.index.calcDetailsTable.headers.expected'
          ),
          thClass: 'text-primary va-middle'
        },
        {
          key: 'asOn',
          label: this.$t(
            'chargesCalculator.index.calcDetailsTable.headers.asOn'
          ),
          thClass: 'text-primary va-middle'
        }
      ],
      invoice_date: new Date(),
      searchQuery: ''
    }
  },
  components: {
    Multiselect,
    DatePicker,
    Loader
  },
  created() {
    this.initialFetch()
  },
  computed: {
    tableItems: function () {
      const {
        value,
        advance_total: advanceTotal,
        disbursed_date: disbursedDate,
        due_date: dueDate,
        received_date: receivedDate,
        received_amount: receivedAmount
      } = this.invoiceDetails
      return [
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.invoiceDetails.fieldItems.value'
          ),
          VALUE: this.formatCurrency(value, this.selectedInvoice.currsym)
        },
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.invoiceDetails.fieldItems.advanceTotal'
          ),
          VALUE: this.formatCurrency(advanceTotal, this.selectedInvoice.currsym)
        },
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.invoiceDetails.fieldItems.disbursedDate'
          ),
          VALUE: disbursedDate
            ? this.$moment.utc(disbursedDate).format('MMMM DD, YYYY')
            : null
        },
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.invoiceDetails.fieldItems.dueDate'
          ),
          VALUE: dueDate
            ? this.$moment.utc(dueDate).format('MMMM DD, YYYY')
            : null
        },
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.invoiceDetails.fieldItems.receivedDate'
          ),
          VALUE: receivedDate
            ? this.$moment.utc(receivedDate).format('MMMM DD, YYYY')
            : null
        },
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.invoiceDetails.fieldItems.receivedAmount'
          ),
          VALUE: this.formatCurrency(
            receivedAmount,
            this.selectedInvoice.currsym
          )
        }
      ]
    },
    tableBreakupItems: function () {
      const advanceRows = []
      this.invoiceDetails.expected_fee_calculation.advances.forEach(
        (el, index) => {
          advanceRows.push({
            PARTICULARS: `Advance #${index + 1} ${this.$t(
              'chargesCalculator.index.calcDetailsTable.advanceDuration'
            )}`,
            expectedOnDueDate: el.duration,
            asOn: this.invoiceCalculationOnDate.advances[index]
              ? this.invoiceCalculationOnDate.advances[index].duration
              : null
          })
          advanceRows.push({
            PARTICULARS: `Advance #${index + 1} ${this.$t(
              'chargesCalculator.index.calcDetailsTable.advanceRegularInterest'
            )}`,
            expectedOnDueDate: this.formatCurrency(
              el.regular_interest,
              this.selectedInvoice.currsym
            ),
            asOn: this.formatCurrency(
              this.invoiceCalculationOnDate.advances[index]
                ? this.invoiceCalculationOnDate.advances[index].regular_interest
                : null,
              this.selectedInvoice.currsym
            )
          })
        }
      )
      // flag to check if dbr interest is coming from backend or not
      const isDBRExists =
        !!this.invoiceDetails.expected_fee_calculation.step_up_dbr_interest ||
        !!this.invoiceCalculationOnDate.step_up_dbr_interest

      // Add rows for Step up duration in DBR
      const stepUpDbrDuration =
        this.invoiceDetails.expected_fee_calculation.step_up_dbr_duration || []
      const invoiceCalculationStepUp =
        this.invoiceCalculationOnDate.step_up_dbr_duration || []

      const stepUpDbrRows = stepUpDbrDuration.reduce((rows, current, index) => {
        const asOnDays = invoiceCalculationStepUp[index]
          ? invoiceCalculationStepUp[index].days
          : 0
        const asOnRate = invoiceCalculationStepUp[index]
          ? invoiceCalculationStepUp[index].rate
          : 0
        const daysRow = {
          PARTICULARS: `${this.$t(
            'chargesCalculator.index.calcDetailsTable.stepUpDbrDuration'
          )} #${index + 1}`,
          expectedOnDueDate: current.days,
          asOn: asOnDays
        }
        const rateRow = {
          PARTICULARS: `${this.$t(
            'chargesCalculator.index.calcDetailsTable.stepUpDbrRate'
          )} #${index + 1}`,
          expectedOnDueDate: `${current.rate}%`,
          asOn: `${asOnRate}%`
        }

        return isDBRExists ? rows.concat(daysRow, rateRow) : []
      }, [])

      const originalArray = [
        {
          PARTICULARS: '',
          expectedOnDueDate: `<div class="desc-text">${this.$t(
            'chargesCalculator.index.calcDetailsTable.firstRow.firstColumn'
          )}</div>`,
          asOn: `<div class="desc-text">${this.$t(
            'chargesCalculator.index.calcDetailsTable.firstRow.secondColumn'
          )}</div>`
        },
        {
          PARTICULARS: this.customWrapper(
            this.$t('chargesCalculator.index.calcDetailsTable.duration')
          ),
          expectedOnDueDate:
            this.invoiceDetails.expected_fee_calculation.duration,
          asOn: this.invoiceCalculationOnDate.duration
        },
        ...stepUpDbrRows,
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.calcDetailsTable.overdue'
          ),
          expectedOnDueDate:
            this.invoiceDetails.expected_fee_calculation.overdue,
          asOn: this.invoiceCalculationOnDate.overdue
        },
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.calcDetailsTable.factoringRate'
          ),
          expectedOnDueDate:
            this.invoiceDetails.expected_fee_calculation.factoring_rate + '%',
          asOn: this.invoiceCalculationOnDate.factoring_rate + '%'
        },
        {
          PARTICULARS: this.customWrapper(
            this.$t('chargesCalculator.index.calcDetailsTable.factoringFees')
          ),
          expectedOnDueDate: this.formatCurrency(
            this.invoiceDetails.expected_fee_calculation.factoring_fees,
            this.selectedInvoice.currsym
          ),
          asOn: this.formatCurrency(
            this.invoiceCalculationOnDate.factoring_fees,
            this.selectedInvoice.currsym
          )
        },
        ...advanceRows,
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.calcDetailsTable.regularInterest'
          ),
          expectedOnDueDate: this.formatCurrency(
            this.invoiceDetails.expected_fee_calculation.regular_interest,
            this.selectedInvoice.currsym
          ),
          asOn: this.formatCurrency(
            this.invoiceCalculationOnDate.regular_interest,
            this.selectedInvoice.currsym
          )
        },
        {
          PARTICULARS: this.$t(
            'chargesCalculator.index.calcDetailsTable.overdueInterest'
          ),
          expectedOnDueDate: this.formatCurrency(
            this.invoiceDetails.expected_fee_calculation.overdue_interest,
            this.selectedInvoice.currsym
          ),
          asOn: this.formatCurrency(
            this.invoiceCalculationOnDate.overdue_interest,
            this.selectedInvoice.currsym
          )
        },
        {
          PARTICULARS: this.customWrapper(
            this.$t(
              `chargesCalculator.index.calcDetailsTable.${
                isDBRExists ? 'totalFees' : 'totalFeesWithoutDBR'
              }`
            )
          ),
          expectedOnDueDate: this.formatCurrencyWithStyle(
            this.invoiceDetails.expected_fee_calculation.total_fees,
            this.selectedInvoice.currsym
          ),
          asOn: this.formatCurrencyWithStyle(
            this.invoiceCalculationOnDate.total_fees,
            this.selectedInvoice.currsym
          )
        },
        {
          PARTICULARS: this.customWrapper(
            this.$t('chargesCalculator.index.calcDetailsTable.totalSettlement')
          ),
          expectedOnDueDate: this.formatCurrencyWithStyle(
            this.invoiceDetails.expected_fee_calculation.total_settlement,
            this.selectedInvoice.currsym
          ),
          asOn: this.formatCurrencyWithStyle(
            this.invoiceCalculationOnDate.total_settlement,
            this.selectedInvoice.currsym
          )
        }
      ]

      const indexToAddOtherChargesAt =
        7 + stepUpDbrRows.length + advanceRows.length
      const indexToRemoveTotalInterestFrom =
        8 + stepUpDbrRows.length + advanceRows.length

      const indiaRFArray = [...originalArray]

      indiaRFArray.splice(indexToAddOtherChargesAt, 0, {
        PARTICULARS: this.$t(
          'chargesCalculator.index.calcDetailsTable.otherCharges'
        ),
        expectedOnDueDate: this.formatCurrency(
          this.invoiceDetails.expected_fee_calculation.other_fees,
          this.selectedInvoice.currsym
        ),
        asOn: this.formatCurrency(
          this.invoiceCalculationOnDate.other_fees,
          this.selectedInvoice.currsym
        )
      })

      originalArray.splice(indexToRemoveTotalInterestFrom - 1, 0, {
        PARTICULARS: this.customWrapper(
          this.$t(
            `chargesCalculator.index.calcDetailsTable.${
              isDBRExists ? 'totalInterest' : 'totalInterestWithoutDBR'
            }`
          )
        ),
        expectedOnDueDate: this.formatCurrency(
          this.invoiceDetails.expected_fee_calculation.total_interest,
          this.selectedInvoice.currsym
        ),
        asOn: this.formatCurrency(
          this.invoiceCalculationOnDate.total_interest,
          this.selectedInvoice.currsym
        )
      })

      if (isDBRExists) {
        if (this.isIndia) {
          indiaRFArray.splice(indexToRemoveTotalInterestFrom, 0, {
            PARTICULARS: this.$t(
              'chargesCalculator.index.calcDetailsTable.stepUpDbrInterest'
            ),
            expectedOnDueDate: this.formatCurrency(
              this.invoiceDetails.expected_fee_calculation.step_up_dbr_interest,
              this.selectedInvoice.currsym
            ),
            asOn: this.formatCurrency(
              this.invoiceCalculationOnDate.step_up_dbr_interest,
              this.selectedInvoice.currsym
            )
          })
        } else {
          originalArray.splice(indexToRemoveTotalInterestFrom - 1, 0, {
            PARTICULARS: this.$t(
              'chargesCalculator.index.calcDetailsTable.stepUpDbrInterest'
            ),
            expectedOnDueDate: this.formatCurrency(
              this.invoiceDetails.expected_fee_calculation.step_up_dbr_interest,
              this.selectedInvoice.currsym
            ),
            asOn: this.formatCurrency(
              this.invoiceCalculationOnDate.step_up_dbr_interest,
              this.selectedInvoice.currsym
            )
          })
        }
      }

      return this.isIndia ? indiaRFArray : originalArray
    },
    options() {
      return {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        debug: true,
        locale: this.$i18n.locale === 'es-MX' ? 'es' : 'en'
      }
    },
    isIndia() {
      return this.$store.state.account.country === 'India'
    }
  },
  methods: {
    async onSelect(e) {
      if (e?.id) {
        this.$mpTrack('Charges calc - Invoice selected', {
          invoice_id: e.id
        })
        this.loading = true
        this.invoice_date = new Date()
        return invoiceService
          .getInvoiceCalculationDetails(e.id)
          .then((res) => {
            this.invoiceDetails = res.data
            const formattedDate = this.$moment(
              this.invoice_date,
              'DD/MM/YYYY'
            ).format('YYYY-MM-DD')
            return invoiceService
              .getCalculationDetailsOnDate(e.id, formattedDate)
              .then((res) => {
                this.loading = false
                this.invoiceCalculationOnDate = res.data
              })
              .catch((e) => {
                console.log(e)
              })
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    formatDate(str) {
      return this.$moment(str, 'DD/MM/YYYY').format('YYYY-MM-DD')
    },
    onDateSelect(e) {
      const newDate = this.$moment(e, 'DD/MM/YYYY').format('YYYY-MM-DD')
      this.$mpTrack('Charges calc - Change date', {
        date: newDate
      })
      invoiceService
        .getCalculationDetailsOnDate(this.selectedInvoice.id, newDate)
        .then((res) => {
          this.invoiceCalculationOnDate = res.data
        })
        .catch((e) => {})
    },
    formatCurrency(value, symbol) {
      return this.$options.filters.currency(value, symbol, ',', 2)
    },
    formatCurrencyWithStyle(value, symbol) {
      const amount = this.$options.filters.currency(value, symbol, ',', 2)
      return `<div class="text-primary font-weight-bold">${amount}</div>`
    },
    customWrapper(value) {
      return `<div class="text-primary font-weight-bold">${value}</div>`
    },
    async initialFetch() {
      this.loading = true
      const invId = this.$route.query.invoiceId
      await this.getInvoices()
      if (invId) {
        this.$router.push(this.$route.path)
        this.selectedInvoice = this.invoices.find(
          (el) => el.id === parseInt(invId)
        )
        return invoiceService
          .getInvoiceCalculationDetails(this.selectedInvoice.id)
          .then((res) => {
            this.invoiceDetails = res.data
            return invoiceService
              .getCalculationDetailsOnDate(
                this.selectedInvoice.id,
                this.invoice_date
              )
              .then((resp) => {
                this.invoiceCalculationOnDate = resp.data
                this.loading = false
              })
              .catch((e) => {
                console.log(e)
              })
          })
          .catch((e) => {
            console.log(e)
            this.loading = false
          })
      }
      this.loading = false
    },
    getInvoices() {
      const limit = 100
      const serializer = 'Business::InvoiceListSerializer'
      const filterBy = { filters: ['advanced'] }
      return invoiceService
        .fetch(
          this.$store.state.account.accountId,
          filterBy,
          null,
          limit,
          serializer
        )
        .then((res) => {
          const filteredInvoices = res.data['drip/business/invoices'].map(
            ({ id, reference, currsym }) => ({ id, reference, currsym })
          )
          this.invoices = filteredInvoices
        })
        .catch((e) => {
          console.log(e)
        })
    },
    searchChange(value) {
      this.searchQuery = value
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/_charges-calculator.scss';
</style>
